import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogComponent } from '../shared/generic-dialog/generic-dialog.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private dialog: MatDialog, private sanitizer: DomSanitizer) {}

  openDialog(
    type: DialogType,
    title: string,
    content: string,
    width?: string
  ): MatDialogRef<GenericDialogComponent> {
    const sanitizedContent: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(content);
    return this.dialog.open(GenericDialogComponent, {
      data: { type, title, content: sanitizedContent },
      width: width || undefined, 
        ariaDescribedBy: 'dialog-content'
    });
  }


  closeAllDialogs(): void {
    this.dialog.closeAll();
  }
}

export enum DialogType {
  ERROR = 'error',
  ALERT = 'alert',
  OK = 'ok',
  SUCCESS = 'success'
}

